export default __webpack_public_path__ + "static/media/discordMessage.c6ece1b4.mp3";